export default class HTTPError extends Error {
  constructor(statusCode, data) {
    super();

    this.statusCode = statusCode;
    this.data = data;
  }
}
